import Controller from '@ember/controller'
import {
  serialize as serializeSort,
  deserialize as deserializeSort,
  updateSortColumns,
} from '@blakeelearning/data-tables/utils/sorting'
import { tracked } from '@glimmer/tracking'

export default class FastPhonicsReportingProgressReviewStudentsController extends Controller {
  queryParams = ['sort']

  @tracked sort = 'first_name'

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  updateSorts = ({ sortKey }: SortObject) => {
    if (sortKey) {
      const newSortConfig = updateSortColumns(this.sortingConfig, sortKey as string)
      this.sortingConfig = newSortConfig
    }
  }
}
